module.exports = __webpack_public_path__ + "img/sosial5.c30109fe.svg";